/**
 * SwitchToggle — On/Off-Switch im Valeszka-Style.
 *
 * Ersetzt manuelle `w-10 h-6 rounded-full bg-[#0A0A0A]` Muster.
 * Variants folgen dem Farbschema der Bereiche:
 *   - "neutral" (default) — #0A0A0A on / #E5E5E5 off
 *   - "stx"                — stx-accent on
 *   - "success"            — emerald on (Ja/Nein Genehmigungen)
 */
export default function SwitchToggle({
  checked = false,
  disabled = false,
  onChange,
  variant = "neutral",
  size = "md",
  testId,
  ariaLabel,
  className = "",
}) {
  const V = {
    neutral: { on: "bg-[#0A0A0A]", off: "bg-[#E5E5E5]" },
    stx:     { on: "bg-stx-accent", off: "bg-stx-border" },
    success: { on: "bg-emerald-600", off: "bg-[#E5E5E5]" },
  }[variant] || { on: "bg-[#0A0A0A]", off: "bg-[#E5E5E5]" };

  const S = {
    sm: { w: "w-8 h-5", knob: "w-4 h-4 m-0.5" },
    md: { w: "w-10 h-6", knob: "w-5 h-5 m-0.5" },
    lg: { w: "w-12 h-7", knob: "w-6 h-6 m-0.5" },
  }[size] || { w: "w-10 h-6", knob: "w-5 h-5 m-0.5" };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => !disabled && onChange && onChange(!checked)}
      data-testid={testId}
      data-active={checked ? "true" : "false"}
      className={`${S.w} rounded-full flex items-center transition-colors shrink-0 disabled:opacity-40 disabled:cursor-not-allowed ${checked ? `${V.on} justify-end` : `${V.off} justify-start`} ${className}`}
    >
      <span className={`${S.knob} rounded-full bg-white shadow-sm transition-transform`} />
    </button>
  );
}
